export const REQUEST_SUCCESS = 'VARUNA.API_REQUEST_SUCCESS'
export const REQUEST_REJECTED = 'VARUNA.API_REQUEST_REJECTED'
export const REQUEST_PENDING = 'VARUNA.API_REQUEST_PENDING'
